"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.menuPlannerRecipeFragment = void 0;
const client_1 = require("@apollo/client");
exports.menuPlannerRecipeFragment = client_1.gql `
  fragment MenuPlannerRecipe on Recipe {
    __typename
    id
    name
    pictureUrl
    source
    rating
  }
`;
//# sourceMappingURL=menuPlannerRecipe.js.map